import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import OnrcAllotedSubDistfps from "./OnrcAllotedSubDistfps";

const intFormat = new Intl.NumberFormat("en-IN");
const qtlFormat = new Intl.NumberFormat("en-IN", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});
const Months = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];
const getMonthName = (m) => Months[m - 1];
const OnrcAllotedSubDistAfso = ({
  month,
  year,
  comm_id,
  dist_code,
  heading,
  commname,
  dist,
  scheme,
    reportType,

  setFpsView
}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [schemeNames, setSchemeNames] = useState([]);
  //const [reportType, setReportType] = useState("IMPDS");

  /* ---------- FETCH ---------- */
  useEffect(() => {
    setLoading(true);

    fetch(`${process.env.REACT_APP_URL_SALE}/reports/afso-wise`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        month,
        year,
        comm_id,
        scheme_id: scheme === "0" ? null : scheme,
        dist_code,
        report_type: reportType
        
      })
    })
      .then(res => res.json())
      .then(json => {
        if (json?.rep_code === "200" && Array.isArray(json.data)) {
          setData(json.data);

          if (json.data[0]?.schemelist) {
            const names = Object.keys(json.data[0].schemelist)
              .filter(k => k.endsWith("_fps"))
              .map(k => k.replace("_fps", ""));
            setSchemeNames(names);
          }
        } else {
          setData([]);
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [month, year, comm_id, scheme, dist_code,reportType]);

  /* ---------- TOTALS ---------- */
  const totals = schemeNames.reduce((acc, s) => {
    data.forEach(r => {
      //acc[`fps_${s}`] = (acc[`fps_${s}`] || 0) + (r.schemelist?.[`${s}_fps`] || 0);
      acc[`cards_${s}`] = (acc[`cards_${s}`] || 0) + (r.schemelist?.[`${s}_cards`] || 0);
      //acc[`trans_${s}`] = (acc[`trans_${s}`] || 0) + (r.schemelist?.[`${s}_trans`] || 0);
      acc[`qty_${s}`] = (acc[`qty_${s}`] || 0) + (r.schemelist?.[`${s}_qty`] || 0);
    });
    return acc;
  }, {});
  const columnTotal = (metric, scheme) =>
    data.reduce(
      (sum, r) => sum + (r.schemelist?.[`${scheme}_${metric}`] || 0),
      0
    );

  const metricGrandTotal = (metric) =>
    schemeNames.reduce(
      (sum, s) => sum + columnTotal(metric, s),
      0
    );

  /* ---------- EXCEL ---------- */
  // const exportExcel = () => {
  //   const aoa = [
  //     [`Mandal Wise Allotment - ${dist} (${month}/${year})`],
  //     [
  //       "Sl.No",
  //       "Mandal",
  //       ...["FPS", "CARDS", "TRANS", "QTY"].flatMap(h =>
  //         [...schemeNames, "Total"].map(s => `${h}-${s}`)
  //       )
  //     ]
  //   ];

  //   data.forEach((r, i) => {
  //     const row = [i + 1, r.afso_name_en];

  //     ["fps", "cards", "trans", "qty"].forEach(f => {
  //       schemeNames.forEach(s => row.push(r.schemelist?.[`${s}_${f}`] || 0));
  //       row.push(
  //         schemeNames.reduce(
  //           (sum, s) => sum + (r.schemelist?.[`${s}_${f}`] || 0),
  //           0
  //         )
  //       );
  //     });

  //     aoa.push(row);
  //   });
  //   //  GRAND TOTAL ROW
  //   const totalRow = ["", "Total"];

  //   ["fps", "cards", "trans", "qty"].forEach(f => {
  //     // scheme column totals
  //     schemeNames.forEach(s => {
  //       totalRow.push(columnTotal(f, s));
  //     });

  //     // grand total per metric
  //     totalRow.push(metricGrandTotal(f));
  //   });

  //   aoa.push(totalRow);

  //   const ws = XLSX.utils.aoa_to_sheet(aoa);
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "Mandal");
  //   XLSX.writeFile(wb, `Mandal_Allotment_${dist}_${month}_${year}.xlsx`);
  // };

  const exportExcel = () => {
    const table = document.getElementById("AFSOTable");

    const wb = XLSX.utils.table_to_book(table, { sheet: "District" });

    XLSX.writeFile(
      wb,
      `Mandal_Allotment_${getMonthName(month)}_${year}.xlsx`
    );
  };

  if (loading) return <div align="center"><b>Loading...</b></div>;
  if (!data.length) return <div align="center">No data found</div>;

  return (
    <div style={{ overflowX: "auto" }}>
      <table id="AFSOTable" width="100%" border="1" cellPadding="5">
        <thead>
          <tr className="tableheader">
            <th colSpan={2 + (schemeNames.length + 1) * 4}>
              {heading}
            </th>
          </tr>

          {/* LEVEL 1 */}
          <tr className="tableheader">
            <th rowSpan={2}>Sl.No</th>
            <th rowSpan={2}>Mandal</th>
            <th colSpan={2}>FPS</th>
            {["CARDS", "QTY"].map(h => (
              <th key={h} colSpan={schemeNames.length + 1}>{h}</th>
            ))}
          </tr>

          {/* LEVEL 2 */}
          <tr className="tableheader">
            <th>Total FPS</th>
            <th>Total Sale FPS</th>
            {["CARDS", "QTY"].flatMap(() =>
              [...schemeNames, "Total"].map(s => (
                <th key={s}>{s}</th>
              ))
            )}
          </tr>
        </thead>

        <tbody>
          {data.map((row, i) => (
            <tr key={row.afso_code}>
              <td>{i + 1}</td>
              <td>
                <span
                  style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
                  onClick={() => {
                    setFpsView(
                      <OnrcAllotedSubDistfps
                        month={month}
                        year={year}
                        comm_id={comm_id}
                        dist_code={dist_code}
                        afso_code={row.afso_code}
                        reportType={reportType}
                        heading={`FPS Wise - ${row.afso_name_en}-${commname}-${getMonthName(month)} ${year}-${reportType}`}

                        commname={commname}
                        dist={dist}
                        mandal={row.afso_name_en}
                        scheme={scheme}
                      />
                    );
                  }}
                >
                  {row.afso_name_en} ({row.afso_code})
                </span>
              </td>
              <td align="right">{intFormat.format(row.totalShops || 0)}</td>
              <td align="right">{intFormat.format(row.total_sale_fps || 0)}</td>

              {["cards", "qty"].flatMap(f => {
                const values = schemeNames.map(
                  s => row.schemelist?.[`${s}_${f}`] || 0
                );
                const total = values.reduce((a, b) => a + b, 0);

                return [
                  ...values.map((v, idx) => (
                    <td key={`${f}-${idx}`} align="right">
                      {f === "qty" ? qtlFormat.format(v) : intFormat.format(v)}
                    </td>
                  )),
                  <td key={`${f}-t`} align="right">
                    {f === "qty" ? qtlFormat.format(total) : intFormat.format(total)}
                  </td>
                ];
              })}
            </tr>
          ))}
          <tr className="tableheader">
            <td colSpan={2} align="right"><b>Total</b></td>
            <td align="right">
              <b>
                {intFormat.format(
                  data.reduce((sum, r) => sum + (r.totalShops || 0), 0)
                )}
              </b>
            </td>

            <td align="right">
              <b>
                {intFormat.format(
                  data.reduce((sum, r) => sum + (r.total_sale_fps || 0), 0)
                )}
              </b>
            </td>

            {["cards", "qty"].flatMap(f => {
              return [
                ...schemeNames.map(s => (
                  <td key={`${f}-${s}`} align="right">
                    <b>
                      {f === "qty"
                        ? qtlFormat.format(columnTotal(f, s))
                        : intFormat.format(columnTotal(f, s))}
                    </b>
                  </td>
                )),
                <td key={`${f}-grand`} align="right">
                  <b>
                    {f === "qty"
                      ? qtlFormat.format(metricGrandTotal(f))
                      : intFormat.format(metricGrandTotal(f))}
                  </b>
                </td>
              ];
            })}
          </tr>

        </tbody>
      </table>

      <br />
      <div align="center">
        <button className="button button2" onClick={exportExcel}>
          Download Excel
        </button>
      </div>
      <br /><br /><br />
    </div>
  );
};

export default OnrcAllotedSubDistAfso;
